import Vue from "vue"
import VueI18n from "vue-i18n"
import zh_tw from "@/locales/zh-tw"
import zh_cn from "@/locales/zh-cn"
import en from "@/locales/en"

Vue.use(VueI18n)

const messages = {
  "zh-tw": zh_tw,
  "zh-cn": zh_cn,
  en,
}

export default new VueI18n({
  locale:
    sessionStorage.getItem("Accept-Language") ||
    (navigator.language.split("-")[0] === "zh" ? navigator.language.toLowerCase() : navigator.language.split("-")[0]),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "zh-tw",
  messages: messages,
})
